<template>
    <section class="w-full">
        <div class="pda-default">
            <div class="t-headline5">
                {{$t('1692')}}
                <!-- 회원가입 완료! -->
            </div>
            <div class="t-body3 mgt-6 t-color-content1">
                {{$t('1693')}}<br>
                {{$t('1694',{str: brandName})}}
                <!-- 학생 계정 회원가입이 완료되었습니다.<br>
                {{brandName}}에서 바로 학습을 시작해보세요. -->
            </div>
            <div class="mgt-35">
                <button class="mdc-button mdc-button--raised btn-red w-full btn-big" @click="moveDegree()">
                    {{$t('1695')}}
                    <!-- 학습 시작하기 -->
                </button>
            </div>
        </div>
    </section>
    
</template>

<script>
/**
 * 회원가입 - 승인완료(sign up - approved component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import joinApi from '@/api/joinApi.js'
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'
export default {
    data() {
        return {
            brandName: '',
            studentContents: '',
            parentContents: '',
            instructorContents: '',
        }
    },

    mixins: [joinMixin],

    computed : {
        ...mapState('join',{
            join : state => state,
        }),
    },

    mounted() {
        this.setMaterialUi()
        this.brandName = BRAND_NAME
        
    },

    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('join', ['INIT_JOIN_STORE']),

        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        moveDegree() {
            // this.$router.push('/degree')
            this.$router.push('/login')
        }
    },
}
</script>